import React from 'react';

/*
What the venue list shows, for the shared DataTable.

Sorting is server-side, so only the fields the backend whitelists are marked
sortable.
*/
const venueColumns = handleClick => [
  { field: '_id', headerName: 'id', type: 'string', hide: true, isId: true },
  {
    field: null,
    headerName: '',
    type: 'action',
    align: 'left',
    content: rowData => (
      <span
        className="font-icon icon-edit text-20 cursor-pointer"
        title="Edit venue"
        onClick={() => handleClick('modify', rowData.venueSlugName)}
      />
    ),
  },
  { field: 'venueName', headerName: 'name', type: 'string', sortable: true, align: 'left' },
  { field: 'venueSlugName', headerName: 'slug', type: 'string', sortable: true, align: 'left' },
  { field: 'location', headerName: 'location', type: 'string', align: 'left' },
  { field: 'country', headerName: 'country', type: 'string', sortable: true, align: 'left' },
  { field: 'capacity', headerName: 'capacity', type: 'string', sortable: true, align: 'right' },
  { field: 'createdAt', headerName: 'created', type: 'date', sortable: true, align: 'left', description: 'When the record was created' },
  {
    field: null,
    headerName: '',
    type: 'action',
    align: 'right',
    content: rowData => (
      <span
        className="font-icon icon-trash text-20 cursor-pointer"
        title="Delete venue"
        onClick={() => handleClick('delete', rowData.venueSlugName)}
      />
    ),
  },
];

export default venueColumns;
